import { ServiceFactory, ServiceProvider, createService } from '@tencent/tiny-ioc';


export function onServicesReady<P extends ServiceProvider<any, any>[], R>(
    deps: [...P],
    callback: ServiceFactory<R, P>,
) {
    const awaiter = createService<R>().dependsOn(deps);
    awaiter.register(callback);
}
